module.exports = __webpack_public_path__ + "static/media/bonus_level_2.c485c9e1.png";